import { Link } from "react-router-dom";

const NoMatchFound = () => {
  return (
    <div className="px-4 py-5 my-5 text-center">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>
        <Link to="/">Back to Home</Link>
      </p>
    </div>
  );
};

export default NoMatchFound;
